import { render, staticRenderFns } from "./PranesimasRengiami.vue?vue&type=template&id=bab14376&scoped=true&"
import script from "./PranesimasRengiami.vue?vue&type=script&lang=js&"
export * from "./PranesimasRengiami.vue?vue&type=script&lang=js&"
import style0 from "./PranesimasRengiami.vue?vue&type=style&index=0&id=bab14376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab14376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VContainer,VDataTable,VFooter,VSpacer,VTextField,VToolbar,VTooltip})
